<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.attacment"
          @keydown.esc="dialog.attacment = false"
          :fullscreen="dialog.fullscreen"
          width="1000"
          persistent
          scrollable>
          <v-card v-if="Object.keys(selected.attacment).length > 0"
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Dokumen {{ selected.attacment.title }}

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.attacment = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text
              class="mt-4">
              <div v-if="selected.attacment.url !== ''">
                <div v-if="selected.attacment.url.split('.').pop() !== 'pdf'">
                  <v-img
                    contain
                    alt="amanata" 
                    width="100%"
                    height="auto"
                    :src="selected.attacment.url"
                    class="ma-auto border-radius">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>

                <div v-else>
                  <iframe 
                    :src="`${selected.attacment.url}#toolbar=0`" 
                    allowfullscreen
                    frameborder="0" 
                    width="100%"
                    :height="!dialog.fullscreen ? 700 : 845"
                    style="border-radius: 15px; border: 2px solid #323639;">
                  </iframe>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Pegawai
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="process.load && Object.keys(detail).length < 1"
                flat
                min-height="calc(100vh - 180px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div>
                      <v-img
                        contain
                        width="75"
                        height="75"
                        alt="amanata" 
                        :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
                        class="ma-auto"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <v-spacer />

                    <div
                      class="black--text text-right">
                      <div
                        class="title font-weight-bold line-text-first">
                        PT Rancang Bangun Berkemajuan
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        Ngebel – Tamantirto Kasihan Bantul DIY
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        (+62) 821-2512-4690 | 0274 – 4299322 | umb.uct@gmail.com
                      </div>
                    </div>
                  </div>

                  <v-divider
                    class="mt-4 mb-1"
                    style="border-top: 3px solid black;" />

                  <v-divider
                    style="border-top: 1px solid black;" />
                </v-card-text>
                
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="2">
                      <v-skeleton-loader
                        class="ma-auto"
                        :loading="process.load"
                        type="image">
                      </v-skeleton-loader>
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="py-0">
                      <v-skeleton-loader
                        class="ma-auto"
                        :loading="process.load"
                        type="article, article">
                      </v-skeleton-loader>
                    </v-col>
                  </v-row>

                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="article, article, table">
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat
                min-height="calc(100vh - 180px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div>
                      <v-img
                        contain
                        width="75"
                        height="75"
                        alt="amanata" 
                        :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
                        class="ma-auto"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <v-spacer />

                    <div
                      class="black--text text-right">
                      <!-- <div
                        class="title font-weight-bold line-text-first">
                        {{ company.company_name }}
                      </div> -->

                      <div
                        class="title font-weight-bold line-text-first">
                        PT Rancang Bangun Berkemajuan
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        Ngebel – Tamantirto Kasihan Bantul DIY
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        (+62) 821-2512-4690 | 0274 – 4299322 | umb.uct@gmail.com
                      </div>
                    </div>
                  </div>

                  <v-divider
                    class="mt-4 mb-1"
                    style="border-top: 3px solid black;" />

                  <v-divider
                    style="border-top: 1px solid black;" />
                </v-card-text>

                <v-card-text
                  class="text-center px-8">
                  <v-divider
                    style="border-top: 1px solid black;" />

                  <div
                    class="body-1 font-weight-bold black--text my-1">
                    Data Personal
                  </div>

                  <v-divider
                    class="mb-4"
                    style="border-top: 1px solid black;" />
                  
                  <v-row>
                    <v-col
                      cols="12"
                      md="2">
                      <v-img
                        contain
                        width="100%"
                        height="auto"
                        alt="amanata" 
                        :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member_default.png')"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="font-weight-bold black--text pl-6">
                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Nomor Induk Pegawai
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.code }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Nomor Induk Kependudukan
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.nik }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Nama Lengkap
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.name }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Email
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.email }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Mobilephone
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.mobilephone }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Unit / Divisi
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.unit_name }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Jabatan
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.position }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Level Jabatan
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left">
                          : {{ detail.role }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Bergabung Tanggal
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left text-uppercase">
                          : {{ detail.join_date | date }}
                        </v-col>
                      </v-row>

                      <v-row
                        class="mb-1">
                        <v-col
                          cols="4"
                          class="py-0 text-left">
                          Status
                        </v-col>

                        <v-col
                          cols="8"
                          class="py-0 text-left text-uppercase">
                          : {{ detail.is_active }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-text
                  class="text-center px-8">
                  <v-divider
                    style="border-top: 1px solid black;" />

                  <div
                    class="body-1 font-weight-bold black--text my-1">
                    Data Pegawai
                  </div>

                  <v-divider
                    class="mb-4"
                    style="border-top: 1px solid black;" />

                  <div
                    class="font-weight-bold black--text">
                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Tempat Lahir
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.birthplace !== '' ? detail.birthplace : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Tanggal Lahir
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        <span v-if="detail.birthdate !== ''">
                          : {{ detail.birthdate | date }}
                        </span>

                        <span v-else>
                          : -
                        </span>
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Jenis Kelamin
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.gender !== '' ? detail.gender : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Pendidikan Terakhir
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.last_education !== '' ? detail.last_education : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Status Pegawai
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left text-capitalize">
                        : {{ detail.marital_status !== '' ? detail.marital_status : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Jumlah Anak
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.children_total !== '' ? detail.children_total : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Golongan Darah
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.blood_group !== '' ? detail.blood_group : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Alamat
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.address !== '' ? detail.address : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Shift
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.shift_name !== '' ? detail.shift_name : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Jam Presensi Datang
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.presensi_start_time !== '' ? detail.presensi_start_time : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Jam Presensi Pulang
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.presensi_end_time !== '' ? detail.presensi_end_time : '-' }}
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
                
                <v-card-text
                  class="text-center px-8">
                  <v-divider
                    style="border-top: 1px solid black;" />

                  <div
                    class="body-1 font-weight-bold black--text my-1">
                    Data Pelengkap
                  </div>

                  <v-divider
                    class="mb-4"
                    style="border-top: 1px solid black;" />

                  <div
                    class="font-weight-bold black--text">
                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        NPWP
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.npwp !== '' ? detail.npwp : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        BPJS Ketenagakerjaan
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.bpjs_tk !== '' ? detail.bpjs_tk : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        BPJS Kesehatan
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.bpjs_kes !== '' ? detail.bpjs_kes : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Jumlah Tanggungan
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.jumlah_tanggungan !== '' ? detail.jumlah_tanggungan : '0' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Bank
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.account_bank_name !== '' ? detail.account_bank_name : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Nomor Rekening
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.account_number !== '' ? detail.account_number : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        A.N Rekening
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ detail.account_name !== '' ? detail.account_name : '-' }}
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>

                <v-card-text
                  class="text-center px-8">
                  <v-divider
                    style="border-top: 1px solid black;" />

                  <div
                    class="body-1 font-weight-bold black--text my-1">
                    Data Dokumen
                  </div>

                  <v-divider
                    class="mb-4"
                    style="border-top: 1px solid black;" />

                  <div
                    v-for="(item, index) in list_doc"
                    :key="index"
                    :class="index < list_doc.length - 1 ? 'mb-1' : ''"
                    class="black--text">
                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 font-weight-bold text-left">
                        Dokumen {{ index + 1 }}
                      </v-col>

                      <v-col
                        cols="8"
                        class="py-0 font-weight-bold text-left">
                        : {{ item.title }}
                      </v-col>

                      <v-col
                        cols="2"
                        class="py-0 text-right">
                        <div
                          @click="dialog.attacment = true; selected.attacment = item;"
                          class="blue--text d-flex align-center cursor-pointer">
                          <v-icon small color="blue">mdi-eye-settings</v-icon>
                          
                          <span
                            class="ml-2">
                            Dokumen
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <div v-if="list_doc.length < 1"
                    style="opacity: 60%;">
                    Belum ada data dokumen . . .
                  </div>
                </v-card-text>

                <v-card-text
                  class="text-center px-8">
                  <v-divider
                    style="border-top: 1px solid black;" />

                  <div
                    class="body-1 font-weight-bold black--text my-1">
                    Data Keluarga
                  </div>

                  <v-divider
                    class="mb-4"
                    style="border-top: 1px solid black;" />

                  <div
                    v-for="(item, index) in list_family"
                    :key="index"
                    :class="index < list_family.length - 1 ? 'mb-8' : ''"
                    class="font-weight-bold black--text">
                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Nama Lengkap
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ item.name }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Tempat Lahir
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left text-uppercase">
                        : {{ item.birthplace !== '' ? item.birthplace : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Tanggal Lahir
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left text-uppercase">
                        <span v-if="detail.birthdate !== ''">
                          : {{ detail.birthdate | date }}
                        </span>

                        <span v-else>
                          : -
                        </span>
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Hubungan
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ item.relation !== '' ? item.relation : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Nomor Handphone
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ item.mobilephone !== '' ? item.mobilephone : '-' }}
                      </v-col>
                    </v-row>


                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Jenis Kelamin
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ item.gender !== '' ? item.gender : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Pendidikan
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ item.last_education !== '' ? item.last_education : '-' }}
                      </v-col>
                    </v-row>

                    <v-row
                      class="mb-1">
                      <v-col
                        cols="2"
                        class="py-0 text-left">
                        Pekerjaan
                      </v-col>

                      <v-col
                        cols="10"
                        class="py-0 text-left">
                        : {{ item.job !== '' ? item.job : '-' }}
                      </v-col>
                    </v-row>
                  </div>

                  <div v-if="list_family.length < 1"
                    style="opacity: 60%;">
                    Belum ada data keluarga . . .
                  </div>

                  <v-divider
                    class="mt-8"
                    style="border-top: 1px solid black;" />
                </v-card-text>

                <v-card-actions
                  class="px-8 pb-5">
                  <v-spacer/>
                  
                  <v-btn 
                    :to="`/user/edit/${detail.id}?step=1`"
                    :color="set_color"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon size="20">mdi-circle-edit-outline</v-icon>

                    <span
                      class="ml-2">
                      Ubah Data Pegawai
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          attacment: false
        },

        selected: {
          attacment: {}
        },
        
        detail: {},

        list_family: [],
        list_doc: [],
        
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/user/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data

            this.fetchDocument()

            this.fetchFamily()
          }
        })
      },

      async fetchDocument () {
        let params = {
          user_id: this.$route.params.id
        }

        await get(`admin/user_doc/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list_doc = res.results.data
          }
        })
      },

      async fetchFamily () {
        let params = {
          user_id: this.$route.params.id
        }

        await get(`admin/user_family/data`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list_family = res.results.data
          }
        })
      }
    }
  }
</script>